import axios from 'axios'
import qs from 'qs'

const get = async (url, params) => {
  const res = await axios.get(url, {
    params: params
  })
  return res.data
}

const getBlob = async (url, params) => {
  const res = await axios.get(url, {
    params: params,
    responseType: 'blob'
  })
  return res.data
}

const post = async (url, params) => {
  const res = await axios.post(url, qs.stringify(params))
  return res.data
}

const postJson = async (url, params) => {
  let config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  const res = await axios.post(url, params, config)
  return res.data
}

const postImg = async (url, params) => {
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  const res = await axios.post(url, params, config)
  return res.data
}

export default {
  get,
  getBlob,
  post,
  postJson,
  postImg
}
